import classNames from 'classnames';
import React, { type ReactNode } from 'react';

interface NarrowPageProps {
  children: ReactNode;
  appendClassName?: string;
}

const NarrowPage: React.FC<NarrowPageProps> = ({ appendClassName, children }: NarrowPageProps) => {
  return (
    <div className={classNames('container pb-5 mb-5 pt-2', appendClassName)}>
      <div className='row'>
        <div className='col col-md-10 offset-md-1 col-lg-8 offset-lg-2 col-xl-6 offset-xl-3'>
          {children}
        </div>
      </div>
    </div>
  );
};

export default NarrowPage;
